import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Contact from "../components/Contact";

const Extracts = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");

  const products = [
    { id: 1, name: "Piperine extract", img: "/images/piperine.webp" },
    { id: 2, name: "Fenugreek extract", img: "/images/Fenugreek_extract.webp" },
    { id: 3, name: "Kutki root extract", img: "/images/Kutki_root_extract.webp" },
    { id: 4, name: "Saffron extract", img: "/images/safron_extract.webp" },

    { id: 5, name: "Cisssus extract", img: "/images/Cisssus_extract.webp" },
    { id: 6, name: "Maca root extract", img: "/images/Macarootextract.webp" },
    { id: 7, name: "Tonkgat ali", img: "/images/Tonkgat_ali.webp" },
    { id: 8, name: "Omega 3 powder", img: "/images/Omega3powder.webp" },

    { id: 9, name: "Licorice extract", img: "/images/Licoriceextract.webp" },
    { id: 10, name: "Vitamin C", img: "/images/vitaminc.webp" },
    { id: 11, name: "Natural caffeine", img: "/images/Naturalcaffeine.webp" },
    { id: 12, name: "Ashwagandha", img: "/images/ashwagandha.webp" },

    {
      id: 13,
      name: "Lutein and zeaxanthin extract",
      img: "/images/Lutein_and_zeaxanthin_extract.webp",
    },

    { id: 14, name: "Green coffee", img: "/images/greencofee.webp" },
    { id: 15, name: "Curcumin", img: "/images/Curcumin.webp" },
  ];

  // Filter products based on search
  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          Herbal Extracts Supplier | Aranya Nutraceuticals
        </title>

        <meta
          name="description"
          content="Premium herbal extracts supplier in India including Piperine, Ashwagandha, Curcumin, Maca Root Extract, Licorice Extract, and nutraceutical ingredients."
        />

        <meta
          name="keywords"
          content="herbal extracts, piperine extract, ashwagandha extract, curcumin, maca root extract, nutraceutical ingredients"
        />

        <meta
          property="og:title"
          content="Herbal Extracts Supplier | Aranya Nutraceuticals"
        />

        <meta
          property="og:description"
          content="Premium quality herbal extracts and nutraceutical ingredients supplier in India."
        />

        <meta
          property="og:image"
          content="/images/piperine.webp"
        />
      </Helmet>

      <Navbar />

      <div id="products" className="px-4 md:px-10 py-8 md:py-12">

        {/* Heading + Search */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

          <h2 className="text-xl md:text-2xl font-bold">
            Products
          </h2>

          <div className="flex w-full md:w-[400px]">
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full border border-gray-300 rounded-l px-4 py-2 outline-none focus:border-green-600"
            />

            <button className="bg-green-600 text-white px-5 rounded-r hover:bg-green-700">
              Search
            </button>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">

          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded shadow p-3"
              >
                <img
                  src={product.img}
                  alt={product.name}
                  loading="lazy"
                  width="300"
                  height="200"
                  className="rounded w-full h-40 md:h-48 object-cover"
                />

                <h3 className="mt-2 font-semibold text-sm md:text-base">
                  {product.name}
                </h3>

                <button
                  onClick={() =>
                    navigate(`/product/${product.id}`, {
                      state: product,
                    })
                  }
                  className="mt-2 w-full bg-green-600 text-white py-1 rounded text-sm hover:bg-green-700"
                >
                  More Details
                </button>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-lg">
              No products found.
            </p>
          )}
        </div>
      </div>

      <Contact />
      <Footer />
    </>
  );
};

export default Extracts;